import styled from 'styled-components'
import { InfoPageStyles } from '~/pages/communication/libs/InfoPage/styles'
import { communicationTitleGroupCss } from '~/pages/communication/libs/communicationBaseStyles'

export const SkillsChartCommunicationStyles = {
  Root: InfoPageStyles.Root,
  ContentWrapper: InfoPageStyles.ContentWrapper,
  Title: InfoPageStyles.Title,
  Subtitle: InfoPageStyles.Subtitle,
  Button: InfoPageStyles.Button,

  TitleGroup: styled.div`
    ${communicationTitleGroupCss}
  `,

  ChartContainer: styled.div`
    position: relative;
    width: 100%;
    padding: 20px 0;

    picture,
    img {
      width: 100%;
      height: auto;
      display: block;
      position: relative;
      z-index: 1;
    }
  `,

  StatOverlay: styled.div`
    position: absolute;
    display: flex;
    flex-direction: column;
    gap: 2px;
    z-index: 1;
  `,

  StatPercent: styled.span`
    font-family: 'Poppins', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 1;
    color: #096ef9;
    text-align: center;
  `,

  StatLabel: styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 1.2;
    color: #6b7280;
    text-align: center;
  `,

  Circle: styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 257px;
    height: 257px;
    border-radius: 50%;
    border: 1px solid #e5e9ec;
    background: transparent;
    z-index: 0;
  `,
}
